import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as form } from 'redux-form';
import show from './show/showReducer';
import showPage from './showPage/showPageReducer';
import showSeason from './showSeason/showSeasonReducer';
import formStructure from './formStructure/formStructureReducer';
import faq from './faq/faqReducer';
import file from './file/fileReducer';
import location from './location/locationReducer';
import country from './country/countryReducer';

const reducers = combineReducers({
  show,
  showPage,
  showSeason,
  formStructure,
  faq,
  file,
  location,
  router: routerReducer,
  form,
  country,
});

export default reducers;



// WEBPACK FOOTER //
// ./src/store/reducers.js